import { createStore } from "redux";
import {composeWithDevTools } from 'redux-devtools-extension';

import reducers from "./reducers";

const store = createStore(reducers, process.env.NODE_ENV !== 'production' && composeWithDevTools());

export default store;
